import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-border py-12" data-testid="footer">
            <div className="container-mx">
                <div className="flex flex-col md:flex-row items-start md:items-start justify-between gap-8">
                    <div className="max-w-xs">
                        <div className="flex items-center gap-2 font-display font-bold text-lg">
                            <Zap size={18} className="text-primary-c" fill="#6D5EF8" />
                            <span>AutoAds</span>
                        </div>
                        <p className="mt-2 text-sm text-secondary-c">AI-маркетолог для малого бізнесу</p>
                        <p className="mt-3 text-xs text-faint-c leading-relaxed">
                            Operator: Bizky P1 Sp. z o.o.<br />
                            ul. Tomasza Zana 11A, 20-601 Lublin<br />
                            NIP: 1133103662 · KRS: 0001047924
                        </p>
                    </div>

                    <nav className="flex flex-col gap-3 text-sm text-secondary-c md:items-end" data-testid="footer-nav">
                        <Link to="/regulamin" className="hover:text-text-primary transition" data-testid="footer-link-regulamin">
                            Regulamin / Terms
                        </Link>
                        <Link to="/privacy" className="hover:text-text-primary transition" data-testid="footer-link-privacy">
                            Polityka Prywatności / Privacy
                        </Link>
                        <Link to="/cookies" className="hover:text-text-primary transition" data-testid="footer-link-cookies">
                            Polityka Cookies / Cookies
                        </Link>
                        <Link to="/subprocessors" className="hover:text-text-primary transition" data-testid="footer-link-subprocessors">
                            Sub-processors
                        </Link>
                        <a
                            href="mailto:contact@auto-ads.app"
                            className="hover:text-text-primary transition"
                            data-testid="footer-link-contact"
                        >
                            contact@auto-ads.app
                        </a>
                    </nav>
                </div>

                <div className="mt-8 pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-3 text-xs text-faint-c">
                    <span className="whitespace-normal">© {year} AutoAds · Project of Bizky Freelance Prime</span>
                    <span className="font-mono whitespace-nowrap shrink-0">v1.0 · PL · EN · UA</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;